// extracted by mini-css-extract-plugin
module.exports = {"price":"Price_price__3YW9W","totalPrice":"Price_totalPrice__2cuTo"};